import React from 'react';
import { format } from 'date-fns';

const DispatchCard = ({ dispatch, onViewDetails }) => {
  const getStatusColor = (status) => {
    const colors = {
      pending: '#fbbf24',
      assigned: '#60a5fa',
      in_progress: '#8b5cf6',
      picked_up: '#34d399',
      in_transit: '#3b82f6',
      delivered: '#10b981',
      cancelled: '#ef4444'
    };
    return colors[status] || '#6b7280';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      low: '#10b981',
      medium: '#fbbf24',
      high: '#f97316',
      urgent: '#ef4444'
    };
    return colors[priority] || '#6b7280';
  };

  return (
    <div
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '12px',
        backgroundColor: 'white',
        cursor: 'pointer',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}
      onClick={() => onViewDetails(dispatch)}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            {dispatch.requestId}
          </h3>
          <p style={{ margin: '4px 0', color: '#6b7280', fontSize: '14px' }}>
            {dispatch.itemDescription || 'No description'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span
            style={{
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '500',
              backgroundColor: getStatusColor(dispatch.status) + '20',
              color: getStatusColor(dispatch.status)
            }}
          >
            {dispatch.status.replace('_', ' ').toUpperCase()}
          </span>
          <span
            style={{
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '500',
              backgroundColor: getPriorityColor(dispatch.priority) + '20',
              color: getPriorityColor(dispatch.priority)
            }}
          >
            {dispatch.priority.toUpperCase()}
          </span>
        </div>
      </div>

      <div style={{ marginTop: '12px', fontSize: '14px' }}>
        <div style={{ marginBottom: '8px' }}>
          <strong style={{ color: '#059669' }}>📍 Pickup:</strong>{' '}
          <span style={{ color: '#4b5563' }}>{dispatch.pickupLocation.address}</span>
        </div>
        <div style={{ marginBottom: '8px' }}>
          <strong style={{ color: '#dc2626' }}>📍 Delivery:</strong>{' '}
          <span style={{ color: '#4b5563' }}>{dispatch.deliveryLocation.address}</span>
        </div>
        {dispatch.driverId && (
          <div style={{ marginBottom: '8px' }}>
            <strong>👤 Driver:</strong>{' '}
            <span style={{ color: '#4b5563' }}>{dispatch.driverId.name}</span>
          </div>
        )}
        {dispatch.distanceFromPickup && (
          <div style={{ marginBottom: '8px' }}>
            <strong>📏 Distance from pickup:</strong>{' '}
            <span style={{ color: '#4b5563' }}>{dispatch.distanceFromPickup.toFixed(1)} km</span>
          </div>
        )}
        {dispatch.distanceFromDelivery && (
          <div style={{ marginBottom: '8px' }}>
            <strong>📏 Distance from delivery:</strong>{' '}
            <span style={{ color: '#4b5563' }}>{dispatch.distanceFromDelivery.toFixed(1)} km</span>
          </div>
        )}
      </div>

      <div style={{ marginTop: '12px', fontSize: '12px', color: '#9ca3af' }}>
        Created: {format(new Date(dispatch.createdAt), 'MMM dd, yyyy HH:mm')}
      </div>
    </div>
  );
};

export default DispatchCard;
